import { buildImageFetchSrcSet } from 'helpers/cdn';

// 1x and 2x of the 110px (mobile) and 150px (desktop) profile avatar.
export const PROFILE_AVATAR_WIDTHS = [256, 384];
export const PROFILE_AVATAR_SIZES = '(max-width: 1024px) 110px, 150px';

export type ImagePreload = { srcSet: string; sizes: string };

/** Lets the head preload fetch the same resized file the avatar <img> picks. */
export const getProfileAvatarPreload = (
  avatarUrl: string | null | undefined
): ImagePreload | undefined => {
  const srcSet = avatarUrl
    ? buildImageFetchSrcSet(avatarUrl, PROFILE_AVATAR_WIDTHS)
    : undefined;

  return srcSet ? { srcSet, sizes: PROFILE_AVATAR_SIZES } : undefined;
};
